import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { APP_SIDEBAR_CONST } from 'constant'

const isMiniSideBar = () => {
    const sidebar = localStorage.getItem(APP_SIDEBAR_CONST) || 'false'
    return sidebar === 'false' ? false : true
}

const toggleSidebar = (sidebar: string) => {
    localStorage.setItem(APP_SIDEBAR_CONST, sidebar)
    return sidebar === 'false' ? true : false
}

const initialState = { miniSidebar: isMiniSideBar() }

const DashboardUISlice = createSlice({
    name: 'DashboardUI',
    initialState,
    reducers: {
        TOGGLE_SIDEBAR(state, action: PayloadAction<string>) {
            toggleSidebar(action.payload)
            state.miniSidebar = !state.miniSidebar
        },
    },
})



export const { TOGGLE_SIDEBAR } = DashboardUISlice.actions
export default DashboardUISlice.reducer